// @flow strict

import styled from 'styled-components';

export const RawStyledMassiveHeroContentFooter = styled.div``;
export const StyledMassiveHeroContentFooter = RawStyledMassiveHeroContentFooter;
